// import LoginBG from "./LoginBg.jpeg";
// //PROD AND TEST
// // import LoginBG from "./LoginBg_ahl.jpg";
// import Logo from "./P3S-logo.jpg";

// import Logo150 from "./P3S-logo-150px.png";
// //PROD AND TEST
// // import Logo150 from "./AHL_Logo.jpeg";

// import Logo200 from "./P3S-logo-200px.png";

// export { LoginBG, Logo, Logo150, Logo200 };

import LoginBG_dev from "./LoginBg_ahl.png";
import LoginBG_prod from "./LoginBg_ahl.png";
import Logo_dev from "./logo_v2.svg";
import Logo_prod from "./logo_v2.svg";
import Logo150_dev from "./logo_v2.svg";
import Logo150_prod from "./logo_v2.svg";
import Logo200_dev from "./logo_v2.svg";
import Logo200_prod from "./logo_v2.svg";

export const LoginBG = (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === "demo") ? LoginBG_dev : LoginBG_prod;
export const Logo = (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === "demo") ? Logo_dev : Logo_prod;
export const Logo150 = (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === "demo") ? Logo150_dev : Logo150_prod;
export const Logo200 = (process.env.REACT_APP_ENV === 'dev' || process.env.REACT_APP_ENV === "demo") ? Logo200_dev : Logo200_prod;
